import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "7.5rem",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  controlAreaClass: {
    display: "flex",
    minWidth: "11.25rem",
    width: "30%"
  },
  saveButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    margin: 0,
    padding: 0,
    width: "100%",
  },
  addButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    width: "100%",
  },
  importLastWeekData: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    width: "100%",
    maxWidth: '200px',
    height: '67px',
    backgroundColor: '#ffa500',
    marginRight: '11px',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#ff8800',
    }
  },
  filters: {
    margin: "0.8rem 0",
    display: "flex",
  },
  branchFilter: {
    width: "40%",
    paddingRight: "0.5rem",
  },
  clientQuotasPlantFilter: {
    width: "20%",
    paddingRight: "0.5rem",
  },
  clientQuotasTurnFilter: {
    width: "20%",
    paddingRight: "0.5rem",
  },
  clientQuotasWeekFilter: {
    width: "30%",
    paddingRight: "0.5rem",
  },
  quotasInformation: {
    '&.Mui-disabled': {
      textTransform: "none",
      cursor: "auto",
      height: '67px',
      backgroundColor: "rgba(0, 0, 0, 0.04)",
      margin: '0 16px 0 0',
      borderRadius: 0,
    }
  },
  quantity: {
    '& input': {
      minWidth: '36px',
      textAlign: 'center',
      padding: '18.5px 0px',
    },
    width:'55px',
    minWidth:'36px',
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    }
  },
  quotasInformationNegative: {
    '&.Mui-disabled': {
      textTransform: "none",
      backgroundColor: "rgba(0, 0, 0, 0.04)",
      cursor: "auto",
      height: '67px',
      color: theme.palette.red.main,
      margin: '0 16px 0 0',
      borderRadius: 0,
    }
  },
  textCenter: {
    textAlign: 'center'
  },
  modalMessage: {
    fontSize: '1.3em',
    textAlign: 'center',
    width: '100%',
    display: 'block'
  },
  modalSubmessage: {
    textAlign: 'center',
    width: '100%',
    display: 'block',
    fontSize: '1em'
  },
  fontPrimaryColor: {
    color: theme.palette.primary.main
  },
  marginTop: {
    marginTop: '1rem'
  },
  modalFooterButton: {
    width: '10rem',
    height: '2.5rem'
  },
}));

export default useStyles;
